import { apiClient } from '../../../api';

export type LoginDTO = {
  email_id: string;
  password: string;
};

export type LoginResponse = {
  access_token: string;
  refresh_token: string;
  type: string;
};

export type RefreshTokenDTO = {
  grant_type: 'refresh_token';
  token: string;
};

export type logoutDTO = {
  access_token: string;
  refresh_token: string;
  type: string;
};

export const AuthApiService = () => {
  const login = async (payload: LoginDTO) => {
    const response = await apiClient<LoginResponse>({
      endpoint: '/agent/login',
      method: 'POST',
      data: payload,
      config: {
        skipAuthRefresh: true,
      },
    });

    return response.data;
  };

  const refreshToken = async (payload: RefreshTokenDTO) => {
    const response = await apiClient<LoginResponse>({
      endpoint: '/admin/login/refresh',
      method: 'POST',
      data: payload,
      config: {
        skipAuthRefresh: true,
      },
    });

    return response.data;
  };

  const AuthLogoutService = async (payload: logoutDTO) => {
    const response = await apiClient<any>({
      endpoint: '/admin/logout',
      method: 'POST',
      data: payload,
    });

    return response.data;
  };

  return {
    login,
    refreshToken,
    AuthLogoutService
  };
};
